// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"28":"ce12fe26a52e24c0ef06","57":"70cd82813f81451c9806","614":"faa1442ca84efdaf9d2e","952":"931b548fa3d92da30642"}[chunkId] + "/css/" + {"28":"ShiftPage","57":"index","614":"Approve","952":"TestSettings"}[chunkId] + ".css";
};